import { InteractionStatus } from "@azure/msal-browser";
export const msalConfig = {
  auth: {
    clientId: "c5a9dd07-dbea-4a45-ad4b-4a69619d7d5f", // Replace with your client ID from Azure
    authority:
      "https://login.microsoftonline.com/158f98bd-5889-4f79-bf2c-095781748d8b", // Can be common or your tenant ID
    redirectUri: "https://karrierekonto.btb.gmbh/", // Must match the redirect URI you set up in Azure
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

export function loginRequest() {
  return {
    scopes: ["User.Read"],
    redirectStartPage: "/",
  };
}

export async function getTokensRaw(msalInstance, inProgress) {
  await assureInstanceInitialized(msalInstance, inProgress);
  const tokens = await msalInstance.acquireTokenSilent({
    scopes: ["User.Read"],
    account: msalInstance.getAllAccounts()[0],
  });
  return {
    accessToken: tokens.accessToken,
    idToken: tokens.idToken,
  };
}

async function assureInstanceInitialized(instance, inProgress) {
  return new Promise((resolve) => {
    const checkVariable = () => {
      if (
        instance.controller.initialized &&
        inProgress === InteractionStatus.None &&
        instance.controller.getAllAccounts().length !== 0
      ) {
        resolve(instance);
      } else {
        setTimeout(checkVariable, 100);
      }
    };

    checkVariable();
  });
}

export function forceLogout(msalInstance) {
  const logoutRequest = {
    account: msalInstance.getAllAccounts()[0],
    postLogoutRedirectUri: "/",
  };
  msalInstance.logout(logoutRequest);
  window.location.reload();
}
